/** 予約表作成時に選択可能な ISO 3166-1 alpha-2 国コード（date-holidays 対応・206 件） */
export const RS_COUNTRY_CODES = [
  'JP',
  'AD',
  'AE',
  'AG',
  'AI',
  'AL',
  'AM',
  'AO',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BQ',
  'BR',
  'BS',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HN',
  'HR',
  'HT',
  'HU',
  'IC',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'KE',
  'KM',
  'KN',
  'KR',
  'KY',
  'KZ',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MK',
  'ML',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NO',
  'NZ',
  'PA',
  'PE',
  'PF',
  'PH',
  'PK',
  'PL',
  'PM',
  'PR',
  'PT',
  'PY',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SS',
  'ST',
  'SV',
  'SX',
  'SZ',
  'TC',
  'TD',
  'TG',
  'TH',
  'TN',
  'TO',
  'TR',
  'TT',
  'TW',
  'TZ',
  'UA',
  'UG',
  'US',
  'UY',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'XK',
  'YT',
  'ZA',
  'ZM',
  'ZW',
] as const;

export type RsCountryCode = (typeof RS_COUNTRY_CODES)[number];

export const RS_DEFAULT_COUNTRY_CODE: RsCountryCode = 'JP';

/** セレクト先頭に出す常用国（祝日確認で触りやすい順。RS_COUNTRY_CODES の部分集合） */
export const RS_FREQUENT_COUNTRY_CODES: readonly RsCountryCode[] = [
  'JP',
  'US',
  'CN',
  'KR',
  'TW',
  'GB',
  'DE',
  'FR',
  'AU',
  'SG',
  'TH',
  'VN',
  'IN',
  'CA',
  'BR',
];

export function isRsCountryCode(code: string): code is RsCountryCode {
  return (RS_COUNTRY_CODES as readonly string[]).includes(code);
}
